export const yearlySalesDetailsCRM = (builder) => ({
    yearlySalesDetailsCRM: builder.mutation({
      query: ({ userId, category }) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';  
        return {
          url: '/get_total_amount_CRM',
          method: 'GET',
          params: { userId, category },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });